// Approval only needs the updated state, not every video metadata field.
export const updateVideoPublishState = /* GraphQL */ `
  mutation UpdateVideoPublishState($input: UpdateVideoModelInput!) {
    updateVideoModel(input: $input) {
      id
      publishState
    }
  }
`;

export const listVideos = /* GraphQL */ `
    query MyQuery {
        listVideoModels {
            items {
                createdAt
                id
                owner
                titleEN
                titleTA
            }
        }
    }
`;

export const listRelatedVideoModels = /* GraphQL */ `
  query ListVideoModels(
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        titleEN
        titleTA
        duration
        viewsCount
        imageName
        thumbnailUrl
        status
        publishState
        owner {
          id
          username
          displayName
          firstName
          lastName
          legacyAvatar
          status
        }
      }
      nextToken
    }
  }
`;

export const listVideosWithTags = /* GraphQL */ `
  query ListVideosWithTags(
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        titleEN
        titleTA
        duration
        viewsCount
        likesCount
        dislikesCount
        imageName
        thumbnailUrl
        status
        publishState
        owner {
          id
          username
          displayName
          firstName
          lastName
          legacyAvatar
          status
        }
        tags {
          items {
            id
            tagModel {
              id
              label
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

export const getVideoProcessingStatus = /* GraphQL */ `
  query GetVideoProcessingStatus($id: ID!) {
    getVideoModel(id: $id) {
      id
      status
      errorMessage
      updatedAt
    }
  }
`;

export const listUserModelsWithVideos = /* GraphQL */ `
  query ListUserModels(
    $filter: ModelUserModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        createdAt
        lastName
        emailVerified
        status
        firstName
        displayName
        phone
        country
        bio
        subscribersCount
        updatedAt
        videos {
          items {
            id
            viewsCount
            titleEN
            titleTA
            duration
            createdAt
          }
        }
        interactions(filter: {type: {eq: like}}) {
          items {
            id
            video {
              id
              viewsCount
              titleEN
              titleTA
              duration
              createdAt
            }
          }
        }
      }
      nextToken
    }
  }
`;

export const getUserByUsername = /* GraphQL */ `
 query userByUsername($username: String!) {
  userByUsername(username: $username) {
    items {
      id
        username
        lastName
        emailVerified
        status
        firstName
        displayName
        phone
        country
        bio
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        createdAt
        subscribedTo {
          items {
            id
            subscribedTo {
              id
              displayName
              username
              legacyAvatar
              status
            }
          }
        }
    }
  }
  }
`;

export const getVideoModelWithLikesAndDislikes = /* GraphQL */ `
  query GetVideoModel($id: ID!) {
    getVideoModel(id: $id) {
      id
      ownerId
      authOwner
      owner {
        id
        firstName
        username
        lastName
        displayName
        emailVerified
        status
        subscribersCount
        viewsCount
        legacyAvatar
      }
      titleEN
      titleTA
      descriptionTA
      duration
      viewsCount
      likesCount
      dislikesCount
      commentsCount
      status
      publishState
      primaryCategory {
        id
        nameTA
        nameEN
      }
      secondaryCategory {
        id
        nameTA
        nameEN
      }
      viewsCount
      significantDate
      descriptionEN
      imageName
      thumbnailUrl
      videoUrl
      externalVideoUrl
      comments {
        items {
          id
          message
          createdAt
          replyToId
          likesCount
          dislikesCount
          owner {
            id
            username
            displayName
            emailVerified
            status
            firstName
            lastName
            legacyAvatar
          }
          replies {
            items {
              id
              message
              createdAt
              likesCount
              dislikesCount
              owner {
                id
                username
                displayName
                emailVerified
                status
                firstName
                lastName
                legacyAvatar
              }
            }
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tagModel {
            id
            label
          }
        }
        nextToken
      }
      createdAt
      updatedAt
      videoModelPrimaryCategoryId
      videoModelSecondaryCategoryId
    }
  }
`;

export const getVideoModelGuest = /* GraphQL */ `
  query GetVideoModelGuest($id: ID!) {
    getVideoModel(id: $id) {
      id
      owner {
        id
        firstName
        username
        lastName
        displayName
        emailVerified
        status
        subscribersCount
        viewsCount
        legacyAvatar
      }
      titleEN
      titleTA
      descriptionTA
      duration
      viewsCount
      likesCount
      dislikesCount
      commentsCount
      status
      publishState
      primaryCategory {
        id
        nameTA
        nameEN
      }
      secondaryCategory {
        id
        nameTA
        nameEN
      }
      viewsCount
      significantDate
      descriptionEN
      imageName
      thumbnailUrl
      videoUrl
      externalVideoUrl
      comments {
        items {
          id
          message
          createdAt
          replyToId
          likesCount
          dislikesCount
          owner {
            id
            username
            displayName
            emailVerified
            status
            firstName
            lastName
            legacyAvatar
          }
          replies {
            items {
              id
              message
              createdAt
              likesCount
              dislikesCount
              owner {
                id
                username
                displayName
                emailVerified
                status
                firstName
                lastName
                legacyAvatar
              }
            }
          }
        }
        nextToken
      }
      tags {
        items {
          id
          tagModel {
            id
            label
          }
        }
        nextToken
      }
      createdAt
      updatedAt
      videoModelPrimaryCategoryId
      videoModelSecondaryCategoryId
    }
  }
`;
export const listVideoModelsWithOwner = /* GraphQL */ `
  query ListVideoModels(
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        titleEN
        titleTA
        owner {
          id
          firstName
          lastName
          displayName
          username
          emailVerified
          status
          legacyAvatar
        }
        descriptionTA
        duration
        likesCount
        dislikesCount
        viewsCount
        significantDate
        descriptionEN
        createdAt
        updatedAt
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
      }
      nextToken
    }
  }
`;

// Lightweight category list (id + names + children) for admin forms/dropdowns.
// Avoids the heavy primaryVideos payload of listCategoryModelsWithChildren.
export const listCategoryModelsLite = /* GraphQL */ `
  query ListCategoryModels(
    $filter: ModelCategoryModelFilterInput
    $limit: Int
    $nextToken: String
    $videoFilter: ModelVideoModelFilterInput = { status: { eq: ready }, publishState: { eq: published } }
  ) {
    listCategoryModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        nameEN
        nameTA
        categoryModelChildrenId
        children {
          items {
            id
            nameEN
            nameTA
          }
        }
      }
      nextToken
    }
  }
`;

export const listCategoryModelsWithChildren = /* GraphQL */ `
  query ListCategoryModels(
    $filter: ModelCategoryModelFilterInput
    $limit: Int
    $nextToken: String
    $videoFilter: ModelVideoModelFilterInput = { status: { eq: ready }, publishState: { eq: published } }
  ) {
    listCategoryModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        nameTA
        nameEN
        isFeatured
        categoryModelChildrenId
        children {
          items {
            id
            nameEN
            nameTA
            isFeatured
          }
        }
        primaryVideos(limit: 8, sortDirection: DESC, filter: $videoFilter) {
          items {
            id
            titleEN
            titleTA
            descriptionTA
            descriptionEN
            duration
            likesCount
            dislikesCount
            viewsCount
            status
            publishState
            significantDate
            thumbnailUrl
            imageName
            createdAt
            updatedAt
            owner {
              id
              firstName
              lastName
              displayName
              username
              legacyAvatar
              status
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

// Loads additional pages of a single category's primary videos for the
// "Load More" control on the home page. Mirrors the filter used by
// listCategoryModelsWithChildren so pagination tokens stay consistent.
export const getCategoryPrimaryVideos = /* GraphQL */ `
  query GetCategoryPrimaryVideos($id: ID!, $limit: Int, $nextToken: String, $videoFilter: ModelVideoModelFilterInput = { status: { eq: ready }, publishState: { eq: published } }) {
    getCategoryModel(id: $id) {
      id
      primaryVideos(
        limit: $limit
        nextToken: $nextToken
        sortDirection: DESC
        filter: $videoFilter
      ) {
        items {
          id
          titleEN
          titleTA
          descriptionTA
          descriptionEN
          duration
          likesCount
          dislikesCount
          viewsCount
          status
          publishState
          significantDate
          thumbnailUrl
          imageName
          createdAt
          updatedAt
          owner {
            id
            firstName
            lastName
            displayName
            username
            legacyAvatar
            status
          }
        }
        nextToken
      }
    }
  }
`;
export const listVideoModelsTitlesEN = /* GraphQL */ `
  query ListVideoModels(
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        titleEN
        titleTA
        descriptionEN
        descriptionTA
        thumbnailUrl
        imageName
        duration
        viewsCount
        status
        publishState
        owner {
          id
          username
          displayName
          legacyAvatar
          status
        }
      }
      nextToken
    }
  }
`;
export const listVideoModelsTitlesTA = /* GraphQL */ `
  query ListVideoModels(
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        titleTA
      }
      nextToken
    }
  }
`;
export const videosByStatusWithOwner = /* GraphQL */ `
  query VideosByStatus(
    $status: VideoStatus!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    videosByStatus(
      status: $status
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        owner {
          id
          username
          displayName
          firstName
          lastName
          legacyAvatar
          status
        }
        status
        imageName
        thumbnailUrl
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        updatedAt
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
      }
      nextToken
    }
  }
`;

export const listPublishedFeaturedVideos = /* GraphQL */ `
  query ListPublishedFeaturedVideos(
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        owner {
          id
          username
          displayName
          legacyAvatar
          status
        }
        status
        imageName
        thumbnailUrl
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        updatedAt
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
      }
      nextToken
    }
  }
`;

export const createMessageSimple = /* GraphQL */ `
  mutation CreateMessageModel(
    $input: CreateMessageModelInput!
    $condition: ModelMessageModelConditionInput
  ) {
    createMessageModel(input: $input, condition: $condition) {
      id
      content
      senderId
      receiverId
      conversationId
      senderAuthOwner
      receiverAuthOwner
      createdAt
      updatedAt
      isRead
      lastMessageAt
      __typename
    }
  }
`;

export const updateMessageSimple = /* GraphQL */ `
  mutation UpdateMessageModel(
    $input: UpdateMessageModelInput!
    $condition: ModelMessageModelConditionInput
  ) {
    updateMessageModel(input: $input, condition: $condition) {
      id
      content
      senderId
      receiverId
      conversationId
      senderAuthOwner
      receiverAuthOwner
      createdAt
      updatedAt
      isRead
      lastMessageAt
      __typename
    }
  }
`;
export const getUserModelWithHistory = /* GraphQL */ `
  query GetUserModel($id: ID!) {
    getUserModel(id: $id) {
      id
      interactions(filter: {type: {eq: watch}}, sortDirection: ASC, limit: 30) {
        items {
          id
          createdAt
          video {
            id
            createdAt
            owner {
              id
              firstName
              lastName
              displayName
              username
              emailVerified
              status
              legacyAvatar
            }
            status
            titleEN
            titleTA
            descriptionTA
            duration
            likesCount
            dislikesCount
            viewsCount
            publishState
            significantDate
            descriptionEN
            imageName
            thumbnailUrl
            updatedAt
            videoModelPrimaryCategoryId
            videoModelSecondaryCategoryId
          }
        }
        nextToken
      }
    }
  }
`;

export const getUserModelLite = /* GraphQL */ `
  query GetUserModel($id: ID!) {
    getUserModel(id: $id) {
      id
      firstName
      lastName
      displayName
      username
      emailVerified
      status
      legacyAvatar
      legacyCover
      authOwner
      subscribedTo {
        items {
          subscribedTo {
            id
            displayName
            username
            status
          }
        }
      }
    }
  }
`;

export const getUserModelLiteByUsername = /* GraphQL */ `
  query userByUsername($username: String!) {
    userByUsername(username: $username) {
      items {
        id
        firstName
        lastName
        displayName
        username
        emailVerified
        status
        legacyAvatar
        authOwner
        subscribedTo {
          items {
            subscribedTo {
              id
              displayName
              username
              legacyAvatar
              status
            }
          }
        }
      }
    }
  }
`;

export const getUserModelForSettings = /* GraphQL */ `
  query GetUserModelForSettings($id: ID!) {
    getUserModel(id: $id) {
      id
      firstName
      lastName
      displayName
      username
      email
      phone
      country
      gender
      bio
      emailVerified
      status
      legacyAvatar
      legacyCover
      legacyId
      authOwner
    }
  }
`;

export const getUserModelForSettingsByUsername = /* GraphQL */ `
  query UserForSettingsByUsername($username: String!) {
    userByUsername(username: $username) {
      items {
        id
        firstName
        lastName
        displayName
        username
        email
        phone
        country
        gender
        bio
        emailVerified
        status
        legacyAvatar
        legacyCover
        legacyId
        authOwner
      }
    }
  }
`;

export const listUserModelsForMessageSearch = /* GraphQL */ `
  query ListUserModelsForMessageSearch(
    $limit: Int
    $nextToken: String
  ) {
    listUserModels(limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        username
        displayName
        legacyAvatar
        authOwner
        status
      }
      nextToken
    }
  }
`;

export const getUserModelByLegacyId = /* GraphQL */ `
  query userByLegacyId($legacyId: String!) {
    userByLegacyId(legacyId: $legacyId) {
      items {
        id
        firstName
        lastName
        displayName
        username
        email
        phone
        country
        gender
        bio
        emailVerified
        status
        legacyAvatar
        legacyCover
        legacyId
        subscribedTo {
          items {
            id
            subscribedTo {
              id
              displayName
              username
              legacyAvatar
              status
            }
          }
        }
      }
    }
  }
`;

export const getUserModelNotifications = /* GraphQL */ `
  query NotificationsByUser(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUser(
      userId: $userId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
        profileId
        videoId
        id
        createdAt
        type
        profile {
          id
          firstName
          lastName
          displayName
          username
          legacyAvatar
          status
        }
        comment {
          id
          message
        }
        message {
          id
          content
        }
        video {
          id
          titleEN
          titleTA
          thumbnailUrl
          imageName
        }
      }
      nextToken
    }
  }
`;
export const topVideosByStatus = /* GraphQL */ `
  query TopVideosByStatus(
    $status: VideoStatus!
    $viewsCount: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    topVideosByStatus(
      status: $status
      viewsCount: $viewsCount
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        owner {
          id
          username
          displayName
          firstName
          lastName
          legacyAvatar
          status
        }
        status
        imageName
        thumbnailUrl
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        viewsCount
        publishState
        significantDate
        descriptionEN
        updatedAt
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
      }
      nextToken
    }
  }
`;

export const interactionByUserId = /* GraphQL */ `
  query InteractionByUserId(
    $userId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interactionByUserId(
      userId: $userId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        createdAt
        videoId
        video {
          id
          createdAt
          owner {
            id
            firstName
            lastName
            displayName
            username
            emailVerified
            status
            legacyAvatar
          }
          status
          titleEN
          titleTA
          descriptionTA
          duration
          likesCount
          dislikesCount
          viewsCount
          publishState
          significantDate
          descriptionEN
          imageName
          thumbnailUrl
          updatedAt
          videoModelPrimaryCategoryId
          videoModelSecondaryCategoryId
        }
      }
      nextToken
    }
  }
`;

export const usersBySubscribersCount = /* GraphQL */ `
  query UsersBySubscribersCount(
    $status: UserStatus!
    $subscribersCount: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersBySubscribersCount(
      status: $status
      subscribersCount: $subscribersCount
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        createdAt
        email
        lastName
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        subscribersCount
        legacyAvatar
        updatedAt
        __typename
        videos {
          items {
            id
          }
        }
      }
      nextToken
      __typename
    }
  }
`;

export const getCategoryModel = /* GraphQL */ `
  query GetCategoryModel(
    $id: ID!
    $limit: Int
    $primaryNextToken: String
    $secondaryNextToken: String
  ) {
    getCategoryModel(id: $id) {
      id
      nameTA
      nameEN
      categoryModelChildrenId
      children {
        items {
          id
          nameTA
          nameEN
        }
        nextToken
      }
      primaryVideos(limit: $limit, nextToken: $primaryNextToken, sortDirection: DESC) {
        items {
          id
          titleEN
          titleTA
          thumbnailUrl
          imageName
          status
          publishState
          owner {
            id
            firstName
            lastName
            displayName
            username
            emailVerified
            status
            legacyAvatar
          }
          descriptionTA
          duration
          likesCount
          dislikesCount
          viewsCount
          significantDate
          descriptionEN
          createdAt
          updatedAt
          videoModelPrimaryCategoryId
          videoModelSecondaryCategoryId
        }
        nextToken
      }
      secondaryVideos(limit: $limit, nextToken: $secondaryNextToken, sortDirection: DESC) {
        items {
          id
          titleEN
          titleTA
          thumbnailUrl
          imageName
          status
          publishState
          owner {
            id
            firstName
            lastName
            displayName
            username
            emailVerified
            status
            legacyAvatar
          }
          descriptionTA
          duration
          likesCount
          dislikesCount
          viewsCount
          significantDate
          descriptionEN
          createdAt
          updatedAt
          videoModelPrimaryCategoryId
          videoModelSecondaryCategoryId
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

export const getVideoModelWithTags = /* GraphQL */ `
  query GetVideoModelWithTags($id: ID!) {
    getVideoModel(id: $id) {
      id
      createdAt
      ownerId
      authOwner
      owner {
        id
        username
        firstName
        displayName
        legacyAvatar
        legacyId
        __typename
        status
      }
      status
      titleEN
      titleTA
      imageName
      thumbnailUrl
      descriptionTA
      duration
      likesCount
      dislikesCount
      primaryCategory {
        id
        nameTA
        nameEN
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      secondaryCategory {
        id
        nameTA
        nameEN
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      videoModelPrimaryCategoryId
      videoModelSecondaryCategoryId
      viewsCount
      publishState
      significantDate
      descriptionEN
      tags {
        items {
          id
          videoModelID
          tagModelID
          tagModel {
            id
            label
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;

export const listTagModelsForAutocomplete = /* GraphQL */ `
  query ListTagModelsForAutocomplete($filter: ModelTagModelFilterInput, $limit: Int, $nextToken: String) {
    listTagModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        label
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const videosByOwnerId = /* GraphQL */ `
  query VideosByOwnerId(
    $ownerId: ID!
    $limit: Int
    $nextToken: String
  ) {
    videosByOwner(
      ownerId: $ownerId
      filter: { status: { eq: ready }, publishState: { eq: published } }
      limit: $limit
      nextToken: $nextToken
      sortDirection: DESC
    ) {
      items {
        id
        titleEN
        titleTA
        duration
        viewsCount
        thumbnailUrl
        imageName
        createdAt
        status
        publishState
      }
      nextToken
    }
  }
`;

export const videosByOwnerIdAll = /* GraphQL */ `
  query VideosByOwnerIdAll(
    $ownerId: ID!
    $limit: Int
    $nextToken: String
  ) {
    videosByOwner(
      ownerId: $ownerId
      limit: $limit
      nextToken: $nextToken
      sortDirection: DESC
    ) {
      items {
        id
        titleEN
        titleTA
        duration
        viewsCount
        thumbnailUrl
        imageName
        createdAt
        status
        publishState
        ownerId
        owner {
          id
          username
          displayName
          firstName
          lastName
          legacyAvatar
          status
        }
      }
      nextToken
    }
  }
`;

export const videosByCategoryWithOwner = /* GraphQL */ `
  query VideosByCategoryWithOwner(
    $categoryId: ID!
    $limit: Int
    $nextToken: String
  ) {
    listVideoModels(
      filter: {
        and: [
          { status: { eq: ready } }
          { or: [
            { videoModelPrimaryCategoryId: { eq: $categoryId } }
            { videoModelSecondaryCategoryId: { eq: $categoryId } }
          ]}
        ]
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        owner {
          id
          firstName
          lastName
          displayName
          username
          emailVerified
          status
          legacyAvatar
        }
        status
        imageName
        thumbnailUrl
        titleEN
        titleTA
        duration
        viewsCount
        likesCount
        dislikesCount
        updatedAt
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
      }
      nextToken
    }
  }
`;

export const listUserSubscribersWithDetails = /* GraphQL */ `
  query ListUserSubscribers(
    $filter: ModelUserSubscriberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserSubscribers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        subscriberId
        subscribedToId
        notify
        subscribedTo {
          id
          displayName
          username
          legacyAvatar
          status
        }
      }
      nextToken
    }
  }
`;

export const subscriptionsBySubscriberId = /* GraphQL */ `
  query SubscriptionsBySubscriberId(
    $subscriberId: ID!
    $limit: Int
    $nextToken: String
  ) {
    subscribersBySubscriberId(
      subscriberId: $subscriberId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subscriberId
        subscribedToId
        notify
        subscribedTo {
          id
          displayName
          username
          legacyAvatar
          status
        }
      }
      nextToken
    }
  }
`;

export const checkSubscription = /* GraphQL */ `
  query CheckSubscription(
    $subscriberId: ID!
    $subscribedToId: ModelIDKeyConditionInput
  ) {
    subscribersBySubscriberId(
      subscriberId: $subscriberId
      subscribedToId: $subscribedToId
    ) {
      items {
        id
        subscriberId
        subscribedToId
        notify
      }
    }
  }
`;

export const videosByTagLabel = /* GraphQL */ `
  query VideosByTagLabel($label: String!, $limit: Int, $nextToken: String) {
    tagByLabel(label: $label) {
      items {
        id
        label
        videos(limit: $limit, nextToken: $nextToken) {
          items {
            videoModel {
              id
              createdAt
              titleEN
              titleTA
              duration
              viewsCount
              imageName
              thumbnailUrl
              status
              publishState
              owner {
                id
                username
                displayName
                firstName
                lastName
                legacyAvatar
                status
              }
            }
          }
          nextToken
        }
      }
    }
  }
`;

export const messagesBySenderId = /* GraphQL */ `
  query MessagesBySender(
    $senderId: ID!
    $limit: Int
    $nextToken: String
  ) {
    messagesBySender(
      senderId: $senderId
      sortDirection: DESC
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        isRead
        lastMessageAt
      }
      nextToken
    }
  }
`;

export const messagesByReceiverId = /* GraphQL */ `
  query MessagesByReceiver(
    $receiverId: ID!
    $limit: Int
    $nextToken: String
  ) {
    messagesByReceiver(
      receiverId: $receiverId
      sortDirection: DESC
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        isRead
        lastMessageAt
      }
      nextToken
    }
  }
`;

export const listMessageModelsForAuthOwner = /* GraphQL */ `
  query ListMessageModelsForAuthOwner(
    $filter: ModelMessageModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessageModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        isRead
        lastMessageAt
      }
      nextToken
    }
  }
`;

export const messagesBySenderAuthOwner = /* GraphQL */ `
  query MessagesBySenderAuthOwner(
    $senderAuthOwner: String!
    $limit: Int
    $nextToken: String
  ) {
    messagesBySenderAuthOwner(
      senderAuthOwner: $senderAuthOwner
      sortDirection: DESC
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        isRead
        lastMessageAt
      }
      nextToken
    }
  }
`;

export const messagesByReceiverAuthOwner = /* GraphQL */ `
  query MessagesByReceiverAuthOwner(
    $receiverAuthOwner: String!
    $limit: Int
    $nextToken: String
  ) {
    messagesByReceiverAuthOwner(
      receiverAuthOwner: $receiverAuthOwner
      sortDirection: DESC
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        isRead
        lastMessageAt
      }
      nextToken
    }
  }
`;

export const messagesByConversationId = /* GraphQL */ `
  query MessagesByConversation(
    $conversationId: ID!
    $limit: Int
    $nextToken: String
  ) {
    messagesByConversation(
      conversationId: $conversationId
      sortDirection: ASC
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        isRead
        lastMessageAt
      }
      nextToken
    }
  }
`;

export const onCreateMessageModelSimple = /* GraphQL */ `
  subscription OnCreateMessageModelSimple(
    $filter: ModelSubscriptionMessageModelFilterInput
  ) {
    onCreateMessageModel(filter: $filter) {
      id
      content
      senderId
      receiverId
      conversationId
      senderAuthOwner
      receiverAuthOwner
      createdAt
      isRead
      lastMessageAt
    }
  }
`;

// Simple mutations that avoid returning deeply nested data that can cause resolver errors
export const createInteractionSimple = /* GraphQL */ `
  mutation CreateVideoInteractionModel(
    $input: CreateVideoInteractionModelInput!
  ) {
    createVideoInteractionModel(input: $input) {
      id
      type
      userId
      videoId
      createdAt
    }
  }
`;

export const deleteInteractionSimple = /* GraphQL */ `
  mutation DeleteVideoInteractionModel(
    $input: DeleteVideoInteractionModelInput!
  ) {
    deleteVideoInteractionModel(input: $input) {
      id
    }
  }
`;

export const createCommentInteractionSimple = /* GraphQL */ `
  mutation CreateCommentInteractionModel(
    $input: CreateCommentInteractionModelInput!
  ) {
    createCommentInteractionModel(input: $input) {
      id
      type
      userId
      commentId
      videoId
      createdAt
    }
  }
`;

export const deleteCommentInteractionSimple = /* GraphQL */ `
  mutation DeleteCommentInteractionModel(
    $input: DeleteCommentInteractionModelInput!
  ) {
    deleteCommentInteractionModel(input: $input) {
      id
    }
  }
`;

export const commentInteractionsByUserAndVideo = /* GraphQL */ `
  query CommentInteractionByUserAndVideo(
    $userId: ID!
    $videoId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentInteractionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentInteractionByUserAndVideo(
      userId: $userId
      videoId: $videoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        userId
        commentId
        videoId
      }
      nextToken
    }
  }
`;

export const backfillAuthOwnerMutation = /* GraphQL */ `
  mutation BackfillAuthOwner {
    backfillAuthOwner {
      success
      updatedCount
      message
    }
  }
`;

export const getRecommendationsQuery = /* GraphQL */ `
  query GetRecommendations($videoId: ID!, $userId: ID, $limit: Int) {
    getRecommendations(videoId: $videoId, userId: $userId, limit: $limit) {
      items {
        id
        titleEN
        titleTA
        duration
        viewsCount
        likesCount
        commentsCount
        imageName
        thumbnailUrl
        createdAt
        isFeatured
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        ownerId
        ownerUsername
        ownerDisplayName
        ownerLegacyAvatar
        score
        matchReasons
      }
      source
    }
  }
`;
